import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import _ from "lodash";
import React from "react";
import { dispatcher } from "react-dispatch";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/ComunicadorActions";
import reducer from "./Store/Reducers/ComunicadorReducer";
import Factory from "./Gerenciadores/Factory";
import { changeContentPainel } from "app/Core/Components/PainelFixoDireita/Store/Actions";

class ComunicadorApp extends XAPPComponent {

    componentDidMount() {
        this.startNoticeDispatcher();
    }

    componentDidUpdate(prevProps) {
        if (this.props.Comunicador.error) {
            this.props.showMessage({
                message: this.props.Comunicador.error,
                variant: "error"
            });
            this.props.Comunicador.error = null;
        }

        const { data = null } = this.props.Comunicador;
        if (!_.isNull(data) && !_.isEqual(data, prevProps.Comunicador.data)) {
            this.checkAutoStartMessage();
        }
    }

    componentWillUnmount() {
        this.props.setOpenMessage();
    }

    startNoticeDispatcher = () => {
        const { setNotices } = this.props;
        dispatcher.on(Actions.GET_MENSAGENS_NOTICE, resp => setNotices(resp));
        return () => dispatcher.off(Actions.GET_MENSAGENS_NOTICE);
    };

    checkAutoStartMessage = () => {
        const { setOpenMessage, Comunicador } = this.props;
        Comunicador.data.forEach(item => {
            if (item.autostart === 1) {
                setOpenMessage(item);
                return null;
            }
        });
    };

    render() {
        const { empresadefault = null, empresa = null } = this.props;
        let xappRouteParams = null;
        if (!_.isNull(empresadefault)) {
            xappRouteParams = {
                "empresa": !_.isNull(empresa) ? empresa : empresadefault,
                "idremetente": empresadefault,
                "organizacao": ""
            };
        }
        return (
            <React.Fragment>
                {!_.isNull(xappRouteParams) &&
                    <React.Fragment>
                        <Factory
                            {...this.props}
                            xappRouteParams={xappRouteParams}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInsumos: Actions.getInsumos,
        get: Actions.get,
        list: Actions.list,
        save: Actions.save,
        setOpenMessage: Actions.setOpenMessage,
        removeAppMessage: Actions.removeAppMessage,
        setNotices: Actions.setNotices,
        openDialog: Actions.openDialog,
        showMessage: AppActions.showMessage,
        changeContentPainel: changeContentPainel,
    }, dispatch);
}

function mapStateToProps({ Comunicador, fuse, auth }) {
    return {
        Comunicador: Comunicador,
        open: Comunicador.open,
        preload: Comunicador.preload,
        theme: fuse.settings.mainTheme,
        settings: auth.user.data.settings,
        user: auth.user.data,
        empresadefault: fuse.navigation.empresa,
    };
}

export default withReducer("Comunicador", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(ComunicadorApp)));
